import React, { Component } from 'react'

import { chainesLocales } from './../include/chainesLocales';

class ConsignesModal extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    get labels() {
        return chainesLocales['ConsignesModal'][this.props.lngChild];
    }

    render() {
        return (
            <React.Fragment>
                <h1>
                    {this.props.suffixe === "e366f" || this.props.suffixe === "e366e" ? this.labels.titleNoQuest : this.labels.title}
                </h1>
                <p dangerouslySetInnerHTML={{__html: this.props.config[`MES_CONSIGNE_${this.props.lngChild}`]}} />
            </React.Fragment>
        );
    }
}

export default ConsignesModal;